/** Human-readable bid badge (nil / blind nil / number). */
export function formatBidLabel(bid) {
  if (bid === -2) return 'Blind nil';
  if (bid === 0) return 'nil';
  return String(bid);
}